// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './Article'

// 引入公共方法
import api from '../../api/api'
import urls from '../../api/url'
import urlParam from '../../assets/js/urlParam'
import dateFilter from '../../assets/js/dateFilter'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

//按需引入element模块
//import {Pagination,Message,Loading} from 'element-ui'
//
//Vue.use(Pagination);
//Vue.use(Loading.directive)

// 注册全局api对象，便于每个组件调用而不用每个组件import
Vue.prototype.api = api;
Vue.prototype.urls = urls;
Vue.prototype.urlParam = urlParam;
Vue.prototype.dateFilter = dateFilter;
//Vue.prototype.$message = Message;
//Vue.prototype.$loading = Loading.service

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/article/article_main.js